
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ArticleList } from 'components/articleList'
import { RatingExplanationButton as Button } from 'components/ratingExplanationButton'
import {
  CategoryLinkIcon as Ci,
  ExternalLinkIcon as Ei
} from 'components/linkIcons'
import { ArticleLink } from 'components/articleLink'
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p><em parentName="p">{`Karl Wild`}</em></p>
    <p>{`Wer es in den fünf Kategorien des Schweizer Hotelratings einmal auf Platz eins
geschafft hat, verteidigt die Position mit derselben Leidenschaft wie ein
Spitzenrestaurant seine drei Michelin-Sterne. Es liegen denn auch dieselben
Häuser an der Spitze wie vor einem Jahr. Die Big Fife haben in sämtlichen
Bewertungskriterien die Nase vor – sie sind derzeit schlicht die Besten. Gewiss,
man könnte sich ganz oben vielleicht etwas mehr Abwechslung wünschen. Aber in
einem Hotelrating ist Abwechslung um der Abwechslung willen der Tod der
Glaubwürdigkeit. Und fünfzehn Häuser, die neu Aufnahme gefunden haben, sorgen
allemal für frischen Wind.`}</p>
    <h4>{`Die Kategoriensieger`}</h4>
    <p>{`Bestes Schweizer `}<a parentName="p" {...{
        "href": "#cat-ferien"
      }}><Ci mdxType="Ci" />{`Ferienhotel`}</a>{` ist das `}<strong parentName="p">{`Castello del Sole`}</strong>{`
in Ascona. Bei den `}<a parentName="p" {...{
        "href": "#cat-nice-price"
      }}><Ci mdxType="Ci" />{`Nice-Price-Ferienhotels`}</a>{` bleibt der
`}<strong parentName="p">{`Vitznauerhof`}</strong>{` vorn, bei den `}<a parentName="p" {...{
        "href": "#cat-wellness"
      }}><Ci mdxType="Ci" />{`Wellnesshotels`}</a>{` das `}<strong parentName="p">{`Grand
Resort Bad Ragaz`}</strong>{`, bei den `}<a parentName="p" {...{
        "href": "#cat-stadt"
      }}><Ci mdxType="Ci" />{`Stadthotels`}</a>{` `}<strong parentName="p">{`The Dolder Grand`}</strong>{`
und bei den `}<a parentName="p" {...{
        "href": "#cat-familien"
      }}><Ci mdxType="Ci" />{`Familienhotels`}</a>{` das `}<strong parentName="p">{`Albergo Losone`}</strong>{`. Zu den
interessantesten Neuen zählen The Woodward Hotel in Genf, das Kempinski Palace
in Engelberg, das Bergwelt in Grindelwald und das Parkhotel Margna in
Sils-Baselgia. Jedes dieser Häuser ist auf seine Art eine enorme Bereicherung
für die helvetischen Hotelszene. Bei anderen interessanten Objekten haben wir
entschieden, vorerst die weitere Entwicklung abzuwarten. So etwa beim Luzerner
Château Gütsch. Oder beim Park Gstaad, das zum Verkauf steht. Four Seasons soll
sich für das Management im Mammutchalet interessieren.`}</p>
    <p>{`Hotel des Jahres ist Le Grand Bellevue in Gstaad, das von Märchenprinzen zweimal
vor dem Untergang gerettet wurde und heute ein Traumhotel ist. Hotelier des
Jahres ist Giuseppe Rossi vom Splendide Royal in Lugano, ein auch international
hoch angesehener Mann von Welt. Koch des Jahres ist Sven Wassmer (Memories,
Grand Resort Bad Ragaz), Concierge des Jahres ist Alexander Piderit (Kronenhof,
Pontresina), Newcomer des Jahres ist Andreas Magnus (Kempinski Palace
Engelberg), Aufsteiger des Jahres sind Luzi und Simona Seiler (Parkhotel Margna,
Sils-Baselgia), das Comeback des Jahres gibt Reto Kocher im Mövenpick Basel. Der
Lifetime Award schliesslich geht an Marco Torriani, jahrzehntelang eine der ganz
grossen Persönlichkeiten der Schweizer Tophotellerie.`}</p>
    <ArticleList mdxType="ArticleList" />
    <p>{`Die Schweizer Ferienhotellerie blickt auf ein sehr gutes Jahr 2021 zurück. Zu
verdanken ist dies der Treue der Schweizer Gäste, aber auch der Tatsache, dass
die pandemiebedingten Restriktionen weit weniger streng ausfielen als in unseren
Nachbarländern. Dass uns relativ grosse Freiheiten gelassen wurden, erwies sich
als goldrichtig. Ungleich trauriger steht es nach wie vor um die
Stadthotellerie. Die Zahl der Gäste aus dem Ausland ist zwar wieder im Steigen
und auch der Freizeittourismus ist zieht wieder an, aber viel mehr ist da noch
nicht.`}</p>
    <p>{`So berechtigt die Hoffnungen der Ferienhotellerie auf einen guten Sommer und
Herbst auch sind: Es bleiben viele Fragezeichen. Ob Corona tatsächlich zum
harmlosen Erkältungsvirus schrumpft, wissen wir nicht. Ebenso wenig wissen wir,
wie kriegerische Auseinandersetzungen sich auf das globale Reiseverhalten
auswirken werden. Sicher ist fast nur eines: Auch wenn die Risiken im Ausland
geringer geworden sind, spricht vieles für Ferien im eigenen Land. Namentlich
eine Hotellerie, die qualitativ noch nie so stark war wie heute.`}</p>
    <Button side='right' className='center aligned' mdxType="Button" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;